import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useI18n } from '../lib/i18n';
import { relativeTime } from '../lib/format';
import { useMonitorStatus } from '../lib/monitoring';

const BANNER =
  'mb-5 flex items-start gap-3 rounded-md border border-warning/40 bg-warning-bg px-4 py-3 text-body-sm text-warning-fg dark:bg-warning/10 dark:text-warning-dark';

/**
 * Said at the top of the Monitoring pages when the monitor process is not
 * running — nothing is being checked then, and every status on the page is as
 * old as its last check. And while nothing outside watches this server — the
 * Cloudflare watchdog (deploy/watchdog) not reading it: the monitor runs on the
 * server it watches, so that server going down tells nobody (operator,
 * 2026-10-21: "when server down i didn't get any email or telegram"). Nothing at
 * all while it runs with a watchdog.
 */
export function MonitorBanner() {
  const { t, locale } = useI18n();
  const { data } = useMonitorStatus();
  if (!data) return null;
  return (
    <>
      {!data.running && (
        <div role="status" className={BANNER}>
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          <span>
            {data.seenAt
              ? t('monitoring.monitor.notRunning', { when: relativeTime(data.seenAt, locale) })
              : t('monitoring.monitor.neverRan')}
          </span>
        </div>
      )}
      {data.watchdog === false && (
        <div role="status" className={BANNER}>
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          <span>
            {data.watchdogSeenAt
              ? t('monitoring.monitor.watchdogStopped', { when: relativeTime(data.watchdogSeenAt, locale) })
              : t('monitoring.monitor.noWatchdog')}{' '}
            <Link to="/monitoring/settings" className="font-medium underline underline-offset-2">
              {t('monitoring.monitor.setWatchdog')}
            </Link>
          </span>
        </div>
      )}
    </>
  );
}
